import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-menu-gerencial',
  templateUrl: './menu-gerencial.component.html',
  styleUrls: ['./menu-gerencial.component.scss']
})
export class MenuGerencialComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
